import styled from 'styled-components';
import { colors } from 'styles/theme';

export const Container = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SectionTitle = styled.h3`
  color: ${colors.primary_dark};
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 0;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    
    div {
      justify-content: center;
    }
  }
`; 